import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const braintree = defineConnector({
  identifier: "braintree",
  name: "Braintree",
  tagLine: "Payment processing by PayPal",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.braintreegateway\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Braintree app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Braintree Control Panel](https://www.braintreegateway.com/login) and navigate to **Settings > API**. If you need OAuth access, contact Braintree to register as a partner and obtain OAuth credentials.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/braintree/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Braintree account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Braintree account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://api.braintreegateway.com/oauth/connect",
    tokenEndpoint: () => "https://api.braintreegateway.com/oauth/access_tokens",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.braintreegateway.com/merchants",
  },
});
